const defaultUpfrontForm = {
    upfront: null,
    familia_objetivo: null,
    tipo: null,
    object_id: null,
    content_type: null,
    is_active: true,
}

export default defaultUpfrontForm;